<script lang="typescript">
import { fade } from 'svelte/transition';
import type { Brief } from '../models/Brief';
import { text_area_resize } from '../common/text_area_resize'

export let brief: Brief;
export let readOnlyMode: boolean;

</script>
    
<div in:fade={{delay:400, duration:400}} out:fade={{duration: 400}} class="editingContainer">
    <div class="editorContainer">
        <div class="editor activeEditor" id="briefEditor">
            <form class='briefForm grid pb-4'>
                <div>
                    <label for="audience">Who's the audience?</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.audience} class="shortBriefInput" type="text" name="audience" id="audience"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="shortTermPainPoints">What are the pain points or biggest fears?</label>
                    <p>- Short Term</p>
                    <textarea disabled={readOnlyMode} bind:value={brief.shortTermPainPoints} 
                    class="shortBriefInput" 
                    rows="5" name="shortTermPainPoints" id="shortTermPainPoints"
                    use:text_area_resize
                    />
                    <p>- Long Term</p>
                    <textarea disabled={readOnlyMode} bind:value={brief.longTermPainPoints} 
                    class="shortBriefInput" 
                    rows="5" name="longTermPainPoints" id="longTermPainPoints"
                    use:text_area_resize
                    />
                </div>

                <div>
                    <label for="bigPromise">By reversing the pain points / biggest fears, what is the one big promise you are going to make? How will this change their lives forever?</label><br/>
                    <textarea disabled={readOnlyMode} bind:value={brief.bigPromise} class="shortBriefInput" rows="5" name="bigPromise" id="bigPromise"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="existingSolutions">What solutions exist for the reader's problem(s) already? Why aren't they working?</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.existingSolutions} class="shortBriefInput" rows="5" name="existingSolutions" id="existingSolutions"
                    use:text_area_resize/>
                </div>
                <div>
                    <label for="newClaim">What’s the new claim / root cause / surprising info? How does this new solution we’re offering them work? (the unique mechanism)"</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.newClaim} class="shortBriefInput" rows="3" name="newClaim" id="newClaim"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="paradoxicalQuestion">What's the paradoxical question?</label>
                    <textarea disabled={readOnlyMode} rows="1" bind:value={brief.paradoxicalQuestion} class="shortBriefInput" type="text" name="paradoxicalQuestion" id="paradoxicalQuestion"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="metaphor">What's a metaphor that explains the mechanism?</label>
                    <textarea disabled={readOnlyMode} rows="1" bind:value={brief.metaphor} class="shortBriefInput" type="text" name="metaphor" id="metaphor"
                    use:text_area_resize
                    />
                </div>

                <div>
                    <label for="boldClaim">What is the Bold Claim?</label>
                    <textarea disabled={readOnlyMode} rows="1" use:text_area_resize bind:value={brief.boldClaim} class="shortBriefInput" type="text" name="boldClaim" id="boldClaim"/>
                </div>

                <div>
                    <label for="productDetails">What is the product, and what does it include? (Fascinations here will be powerful)</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.productDetails} class="shortBriefInput" rows="5" name="productDetails" id="productDetails"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="discoveryStory">What is the background story / story of discovery?</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.discoveryStory} class="shortBriefInput" rows="5" name="discoveryStory" id="discoveryStory"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="headlineIdeas">Can you list some one-sentence headline ideas?</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.headlineIdeas} class="shortBriefInput" rows="3" name="headlineIdeas" id="headlineIdeas"
                    use:text_area_resize/>
                </div>

                <div>
                    <label for="upsellIdeas">Ideas for a potential upsell product related to the product that solves an additional problem or adds significant benefit?</label>
                    <textarea disabled={readOnlyMode} bind:value={brief.upsellIdeas} class="shortBriefInput" rows="3" name="upsellIdeas" id="upsellIdeas"
                    use:text_area_resize/>
                </div>

            </form>
        </div>
    </div>
</div>
<!-- <svelte:head>
    <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
    <link href="//cdn.quilljs.com/1.3.6/quill.bubble.css" rel="stylesheet">
</svelte:head> -->
<style>
    /* @import 'https://cdn.quilljs.com/1.3.6/quill.snow.css';
    @import 'https://cdn.quilljs.com/1.3.6/quill.bubble.css'; */

.editingContainer{
    /* width: 100vw; */
    /* height: 100vh; */
    display: flex;
    flex-direction: row;
    /* position: absolute; */
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
}
label{
    font-weight:bold;
}
#briefEditor {
    overflow-y: scroll;
    max-height: 100vh;
}
.editorContainer{
    flex: 1;
    width: 50%;
    max-height: 83vh;
}
.ql-editor{
    overflow-y:scroll;
}
.tabContainer{
    display: flex;
    flex-direction: row;
}
.tab{
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
}
.briefForm{
    padding-left: 5%;
    padding-right: 5%;
}
.active {
    border: black 1px solid;
    border-radius: 5px 5px 0px 0px;
}
.inactive{
    color: rgba(255, 255, 255, 0.657);
    background-color: peachpuff;
}
.editor{
    /* border: black 1px solid; */
    font-family: monospace;
    font-size: x-large;
}
.shortBriefInput{
    width: 95%;
    @apply border-black;
    @apply rounded;
    @apply border-2;
    display: block;
    background-color: rgba(255, 255, 255, 1);
}

.activeEditor{
    height:100%;
}

.inactiveEditor{
    display: none;
}
/* main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
} */

h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
}

#brief{
    width: 100%;
}
#mechanism {
    width: 100%;
}

/* @media (min-width: 640px) {
    main {
        max-width: none;
    }
} */
</style>